<ion-content>
  <ion-row class="mb-10">
    <ion-col size="12" size-lg="auto" class="borderbottomForTab pb-0">
      <nav mat-tab-nav-bar [tabPanel]="tabPanel" class="dwm-header-menu height-100">
        <a *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Employee' || loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD' || userIsAdminTypes?.userIsAdmin" mat-tab-link [routerLink]="['dwm-dashboard']" routerLinkActive #rla1="routerLinkActive" [active]="rla1.isActive" class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">speed</span>
          Dashboard
        </a>

        <a *ngIf=" loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || userIsAdminTypes?.userIsAdmin" mat-tab-link [routerLink]="['employee-dwm']" routerLinkActive #rla2="routerLinkActive" [active]="rla2.isActive" class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">analytics</span>
          Employee DWM
        </a>

        <a *ngIf="loggedInUserRole === 'Employee' || loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD'" mat-tab-link routerLinkActive [matMenuTriggerFor]="myDwmMenu" [active]="rla3.isActive || rla4.isActive" class="dwm-header-menu-nav height-100" #myDwmMenuTrigger="matMenuTrigger" (mouseenter)="mouseenterTriggerMenu(myDwmMenuTrigger)">
          <span class="material-icons mr-10">task</span>
          My DWM
          <span class="material-symbols-outlined">arrow_drop_down</span>
          <mat-menu #myDwmMenu="matMenu">
            <a mat-tab-link [routerLink]="['create-dwm']" routerLinkActive #rla3="routerLinkActive" [active]="rla3.isActive" class="dwm-header-sub-menu">Create DWM</a>
            <a mat-tab-link [routerLink]="['update-dwm']" routerLinkActive #rla4="routerLinkActive" [active]="rla4.isActive" class="dwm-header-sub-menu">Update DWM</a>
          </mat-menu>
        </a>

        <a *ngIf="(loggedInUserRole === 'Manager' || loggedInUserRole === 'HOD' || isRndAdminUser) && loggedInUserRole !== 'Employee'  && loggedInUserRole !== 'Admin'  && loggedInUserRole !== 'HR Admin'" mat-tab-link routerLinkActive [matMenuTriggerFor]="teamDwmMenu" [active]="rla5.isActive || rla6.isActive || rlaExit.isActive" class="dwm-header-menu-nav height-100" #teamDwmMenuTrigger="matMenuTrigger" (mouseenter)="mouseenterTriggerMenu(teamDwmMenuTrigger)">
          <span class="material-icons mr-10">groups</span>
          Team DWM
          <span class="material-symbols-outlined">arrow_drop_down</span>
          <mat-menu #teamDwmMenu="matMenu">
            <a mat-tab-link [routerLink]="['approve-dwm']" routerLinkActive #rla5="routerLinkActive" [active]="rla5.isActive" class="dwm-header-sub-menu">Approve Team DWM</a>
            <a mat-tab-link [routerLink]="['review-dwm']" routerLinkActive #rla6="routerLinkActive" [active]="rla6.isActive" class="dwm-header-sub-menu">Review Team DWM</a>
            <a mat-tab-link [routerLink]="['exited-dwm']" routerLinkActive #rlaExit="routerLinkActive" [active]="rlaExit.isActive" class="dwm-header-sub-menu">Exited Team DWM</a>
          </mat-menu>
        </a>

        <a *ngIf="isRndAdminUser && loggedInUserRole !== 'Admin' && loggedInUserRole !== 'HR Admin'"  mat-tab-link [routerLink]="['rndadmin']" routerLinkActive #rla7="routerLinkActive" [active]="rla7.isActive" class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">task</span>
          R&D Admin
        </a>

          <!-- <a *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' " mat-tab-link [routerLink]="['dump-reports']" routerLinkActive #rla8="routerLinkActive" [active]="rla8.isActive" class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">description</span>
          Dump Report
        </a> -->

        <a *ngIf="loggedInUserRole === 'Super Admin' || loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Manager' || 
        loggedInUserRole === 'Employee' || loggedInUserRole === 'HOD' || userIsAdminTypes?.userIsAdmin" mat-tab-link [routerLink]="['reports']" routerLinkActive #rla9="routerLinkActive" [active]="rla9.isActive" class="dwm-header-menu-nav height-100">
          <span class="material-icons mr-10">description</span>
          Reports
        </a>
      </nav>
    </ion-col>

    <ion-col size="12" size-lg class="add-border-bottom-desktop">
      <a *ngIf="loggedInUserRole === 'HR Admin' || loggedInUserRole === 'Super Admin' || userIsAdminTypes?.userIsAdmin" type="button" class="add_btn setup-button fs-14 float-right center-content mr-5" [style.background-color]="buttonColorName" [routerLink]="['/home/hrportal/dwmplus-setup']">
        <span class="material-icons fs-20 mr-5">settings</span>
        Setup
      </a>

      <div>
        <button class="helpdesk_btn  fs-14 float-right center-content mr-5" type="button" (click)="onClickOpenTickets()">
          <span class="material-icons fs-20 mr-5">headset_mic</span>
          Helpdesk
        </button>
      </div>

      <div>
        <button class="helpdesk_btn  fs-14 float-right center-content mr-5" type="button" (click)="onClickResources('helpDesk')">
          <span class="material-icons">library_books</span>
          Resources
        </button>
      </div>
    </ion-col>
  </ion-row>
  <mat-tab-nav-panel #tabPanel>
    <router-outlet></router-outlet>
  </mat-tab-nav-panel>
</ion-content>
